var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoorOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 288C237.25 288 248 273.625 248 256S237.25 224 224 224S200 238.375 200 256S210.75 288 224 288ZM288 0C285.5 0 282.875 0.375 280.25 1L88.25 50.75C74 54.5 64 67.75 64 82.875V464H24C10.746 464 0 474.744 0 488C0 501.254 10.746 512 24 512H288C305.674 512 320 497.672 320 480V33.125C320 14.375 305.25 0 288 0ZM272 464H112V94.125L272 52.75V464ZM552 464H512V128C512 92.652 483.346 64 448 64H352V112H448C456.836 112 464 119.162 464 128V480C464 497.672 478.326 512 496 512H552C565.254 512 576 501.254 576 488C576 474.744 565.254 464 552 464Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOpen);
export default __webpack_public_path__ + "static/media/door-open.dde411d54ed227e9bae51b376b2ec857.svg";
export { ForwardRef as ReactComponent };